export default __webpack_public_path__ + "static/media/img2.5940c65f.PNG";